import { render, staticRenderFns } from "./payName.vue?vue&type=template&id=922b33c0&scoped=true&"
import script from "./payName.vue?vue&type=script&lang=js&"
export * from "./payName.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "922b33c0",
  null
  
)

export default component.exports